import React from "react";

const DiplomaRequestIcon: React.FC<
  React.SVGAttributes<NonNullable<unknown>>
> = (props) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0031 19.6998C13.8257 19.6998 15.3031 18.2224 15.3031 16.3998C15.3031 14.5773 13.8257 13.0999 12.0031 13.0999C10.1806 13.0999 8.70312 14.5773 8.70312 16.3998C8.70312 18.2224 10.1806 19.6998 12.0031 19.6998Z"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M8.82387 16.356L7.67987 17.5L6.05407 19.0587C5.69767 19.4007 5.51948 19.5712 5.45788 19.7164C5.38861 19.8709 5.37954 20.0456 5.43246 20.2064C5.48537 20.3671 5.59643 20.5023 5.74387 20.5854C5.87807 20.6613 6.12117 20.6844 6.60517 20.7328C6.87797 20.7592 7.01547 20.7724 7.12987 20.8131C7.25429 20.8561 7.3679 20.9256 7.46285 21.0167C7.55781 21.1079 7.63185 21.2186 7.67987 21.3411C7.72277 21.4511 7.73707 21.582 7.76457 21.8449C7.81407 22.3091 7.83937 22.5412 7.91857 22.6699C8.09897 22.9636 8.48067 23.0791 8.82497 22.9449C8.97567 22.8844 9.15387 22.7139 9.51027 22.3729L11.9996 19.9859L14.4889 22.3729C14.8453 22.7139 15.0235 22.8844 15.1742 22.9449C15.5185 23.0791 15.9002 22.9636 16.0806 22.6699C16.1598 22.5412 16.1851 22.3091 16.2346 21.8449C16.2621 21.582 16.2764 21.4511 16.3192 21.3411C16.3673 21.2186 16.4414 21.108 16.5363 21.0168C16.6313 20.9257 16.7449 20.8562 16.8692 20.8131C16.9847 20.7724 17.1211 20.7592 17.3939 20.7328C17.8779 20.6855 18.121 20.6613 18.2552 20.5854C18.4027 20.5023 18.5138 20.3671 18.5667 20.2064C18.6196 20.0456 18.6105 19.8709 18.5412 19.7164C18.4796 19.5712 18.3014 19.4007 17.945 19.0587L16.3181 17.5L15.2996 16.4803"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M17.852 18.5956C20.0212 18.5725 21.2312 18.4361 22.0331 17.6331C22.9999 16.6673 22.9999 15.1108 22.9999 12V7.59998C22.9999 4.48919 22.9999 2.9327 22.0331 1.9669C21.0673 1 19.5108 1 16.4 1H7.59998C4.48919 1 2.9327 1 1.9669 1.9669C1 2.9327 1 4.48919 1 7.59998V12C1 15.1108 1 16.6673 1.9669 17.6331C2.8117 18.479 4.10749 18.5846 6.49999 18.5978"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M8.69999 5.3999H15.3M6.5 9.24989H17.5"
      stroke="#8065C9"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

export default DiplomaRequestIcon;
